import React from "react";

const Search = ({
  searchValue,
  changeSearchValue,
  doSearch,
  label,
  className = "",
  placeholder = "Search",
  reactRef = null,
  disabled = false,
  inModal = false
}) => {
  const changeValue = (e) => {
    const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9 &'-]+/g, "");
    changeSearchValue(sanitizedValue);
  };

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      doSearch();
    }
  };

  return (
    <div className="search">
      <input
        className={className}
        placeholder={placeholder}
        value={searchValue}
        onChange={changeValue}
        onKeyPress={onKeyPress}
        ref={reactRef}
        aria-label={`Search our ${label}`}
        role="search"
        disabled={disabled}
      />
      <i onClick={doSearch} className={inModal ? "icon-search icon-invert" : "icon-search--darkish-pink"} />
    </div>
  );
};

export default Search;
